<template>
  <banner-description
    title="workWithUs.joinOurNetwork"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconGreen', imgFormat: 'svg' }"
    :imgObj="{ componentName: 'workWithUs', imgName: 'joinOurNetwork', imgFormat: 'svg' }"
    description="workWithUs.joinOurNetworkDesc"
    descColor="#4E4E4E"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { useWorkWithUsStore } from "@/stores/workWithUs";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const workWithUsStore = useWorkWithUsStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>